module.exports = __webpack_public_path__ + "media/images/athletes/487-65ef387fcadc27ef2c12cdbc236b9111.png";